import * as ObjectExt from './object';
export { ObjectExt };
//# sourceMappingURL=index.js.map